import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  Alert,
  AlertTitle,
  CircularProgress,
} from '@mui/material';

// Second confirmation shown when a checkout is about to be filed with the
// "Schlecht" experience rating. That rating is not just an internal note: it
// mails the guests an apology asking them to describe what went wrong, and
// their answer is filed as a complaint that goes to the management. Staff
// therefore confirm explicitly that the group really left dissatisfied.
function BadRatingConfirmDialog({ open, onClose, onConfirm, loading, customerName }) {
  const guests = customerName && customerName.trim() ? customerName.trim() : 'Die Gruppe';

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>War die Gruppe wirklich unzufrieden?</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Alert severity='warning'>
            <AlertTitle>Diese Bewertung löst eine Entschuldigung aus</AlertTitle>
            {guests} erhält automatisch eine E-Mail mit einer Entschuldigung und der Bitte, den
            Vorfall zu schildern. Die Antwort geht direkt an die Geschäftsführung und wird als
            Beschwerde erfasst.
          </Alert>
          <Typography variant='body2' color='text.secondary'>
            Bitte nur bestätigen, wenn der Besuch tatsächlich negativ erlebt wurde — etwa bei einer
            Beschwerde vor Ort oder sichtbarem Ärger. Bei Kleinigkeiten oder unklarer Stimmung ist
            „Neutral“ die richtige Wahl.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Zurück zur Bewertung
        </Button>
        <Button onClick={onConfirm} variant='contained' color='error' disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Ja, Gruppe war unzufrieden'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default BadRatingConfirmDialog;
